import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { useDataSourceInstance } from '@integration-app/react';
import { LogoLoader } from '../../LogoLoader';
const DataSourceInstanceContext = createContext({
    dataSourceInstance: null,
    loading: false,
    patch: null,
    setup: null,
    reset: null,
    refresh: null,
});
export function useDataSourceInstanceContext() {
    return useContext(DataSourceInstanceContext);
}
export const DataSourceInstanceContextProvider = ({ children, id, fallback, }) => {
    const { dataSourceInstance, patch, setup, reset, refresh, loading } = useDataSourceInstance(id);
    if (loading) {
        return fallback ? fallback() : _jsx(LogoLoader, {});
    }
    return (_jsx(DataSourceInstanceContext.Provider, { value: {
            dataSourceInstance,
            patch,
            setup,
            reset,
            refresh,
            loading,
        }, children: children }));
};
//# sourceMappingURL=data-source-instance-context.js.map